(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.okap = {
    attach: function (context, settings) {

      // Insert your code here.

    }
  };

})(jQuery, Drupal);
